<template>
  <div v-title :data-title="title" class="home-container" :style="{ 'background-image': `url(${settingData.indexBgImage})` }">
    <img class="home-logo" style="width: 100px;height: 29px;" src="../assets/images/logo-block.png"/>
    <div class="home-container-blur" :style="{ 'background-image': `url(${settingData.indexBgImage})` }"></div>
    <header class="header-content box-background" :style="{ 'background-color': settingData.indexHeadColor }">
      <section class="container">
        <p class="logo-box">
          {{ title }}
        </p>
        <p class="login-out" >
          <span @click="onClickLogin"><svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-tuichu"></use>
          </svg>{{ $t('tc') }}</span>
        </p>
      </section>
    </header>

    <section class="container home-content">
      <div class="home-lf scrollbar">
        <div class="avator-box">
          <p class="avator" :style="{ 'background-image': `url(${avatorUrl || avatorUrlInit})` }">
            <Upload
              class="upload-avator"
              :show-upload-list="false"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png']"
              :max-size="2048"
              :on-exceeded-size="handleMaxSize"
              :action="$baseUrl + '/sso/imageFile/uploadBgImage'">
              上传头像
            </Upload>
          </p>
          <p class="name">{{ userInfo.name }}</p>
        </div>
        <div class="desc-cell">
          <span class="name">{{ $t('homePage.gh') }}</span>
          <span class="desc">{{ userInfo.userCode }}</span>
        </div>
        <div class="desc-cell">
          <span class="name">{{ $t('homePage.zh') }}</span>
          <span class="desc">{{ userInfo.userName }}</span>
        </div>
        <div class="desc-cell">
          <span class="name">{{ $t('homePage.gw') }}</span>
          <span class="desc">{{ userInfo.postName }}</span>
        </div>
        <div class="desc-cell">
          <span class="name">{{ $t('homePage.sj') }}</span>
          <span class="desc">{{ userInfo.mobile }}</span>
        </div>
        <div class="desc-cell">
          <span class="name">{{ $t('homePage.yx') }}</span>
          <span class="desc">{{ userInfo.email }}</span>
        </div>
        <div class="action-box">
          <div class="action-cell" @click="languagesModalShow = !languagesModalShow, doGetLanguages()">
            <p class="bg lang-box text-color" :title="$t('homePage.yy')" :style="{ 'background': lightColor }">{{ userInfo.languageChar }}</p>
            <p class="name" :title="$t('homePage.yy')">{{ $t('homePage.yy') }}</p>
          </div>
          <div class="action-cell" @click="skinModalShow = !skinModalShow, doGetSkinList()">
            <p class="bg" :title="$t('homePage.pf')" :style="{ 'background-color': lightColor }">
              <svg class="icon text-color" aria-hidden="true">
                <use xlink:href="#icon-pifu"></use>
              </svg>
            </p>
            <p class="name" :title="$t('homePage.pf')">{{ $t('homePage.pf') }}</p>
          </div>
          <div class="action-cell" @click="loginStyleModalShow = !loginStyleModalShow, doGetBgList()" v-show="isAdmin">
            <p class="bg" :title="$t('homePage.bj')" :style="{ 'background-color': lightColor }">
              <svg class="icon text-color" aria-hidden="true">
                <use xlink:href="#icon-beijing"></use>
              </svg>
            </p>
            <p class="name" :title="$t('homePage.bj')">{{ $t('homePage.bj') }}</p>
          </div>
          <div class="action-cell" @click="agentModalShow = !agentModalShow, doGetAgentList()" v-show="!isAdmin">
            <p class="bg" :title="$t('homePage.yh')" :style="{ 'background-color': lightColor }">
              <svg class="icon text-color" aria-hidden="true">
                <use xlink:href="#icon-yonghu2"></use>
              </svg>
            </p>
            <p class="name" :title="$t('homePage.yh')">{{ $t('homePage.yh') }}</p>
          </div>
          <div class="action-cell" @click="handleUpdatePwd">
            <p class="bg" :title="$t('loginPage.xgmm')" :style="{ 'background-color': lightColor }">
              <svg class="icon text-color" aria-hidden="true">
                <use xlink:href="#icon-yanzhengma"></use>
              </svg>
            </p>
            <p class="name" :title="$t('loginPage.xgmm')">{{ $t('loginPage.xgmm') }}</p>
          </div>
          <p class="action-button box-background" @click="doJumpExternalLinks">{{ $t('loginPage.wbll') }}</p>
        </div>

      </div>
      <div class="home-rt">
        <section class="home-rt-top">
          <!-- <div class="home-rt-top-tab">
            <p class="tab-cell"
             style="max-width: 140px"
             :class="{ 'text-color': currentTabIndex === index }"
             :active="currentTabIndex === index"
             v-for="(item, index) in todoList"
             :key="item.id"
             @click="currentTabIndex = index">
              {{ item.name }} {{item.number > 0 ? `(${item.workNum})` : ''}}
            </p>
          </div> -->
          <div class="home-rt-top-tab">
            <p class="tab-cell"
             style="max-width: 190px"
             :class="{ 'text-color': currentTabIndex === index }"
             :active="currentTabIndex === index"
             v-for="(item, index) in newTodoList"
             :key="item.id"
             @click="checkTop(item, index)"
             >
              {{ item.appName }} {{item.workNum > 0 ? `(${item.workNum})` : ''}}
            </p>
          </div>
          <ul class="home-rt-top-content scrollbar" v-show="currentTabIndex === 0">
            <li class="cell" v-for="(item, index) in totalworkItemList" :key="index">
              <p class="index">
                <span class="circle box-background"></span>
                <span class="circle circle-small" :style="{ 'background-color': lightColor }"></span>
              </p>
              <div class="content">
                <p class="title" @click="toToDeatil(item)"><a target="_blank" @click="handleTimer">{{ item.subject }}</a></p>
                <p class="desc">
                  {{ item.appSign === 'auth-sso' ? item.createTime ? $dayjs(item.createTime).format('YYYY-MM-DD HH:mm') : '' : item.createTime }} | {{ item.applicantName }}  </p>
              </div>
            </li>
            <li class="cell cell-title-nodata" v-if="totalworkItemList.length === 0">{{ $t('mqzwdbcl') }}</li>
          </ul>
          <ul class="home-rt-top-content scrollbar" v-show="currentTabIndex > 0">
            <li class="cell" v-for="(item, index) in newworkItemDetail" :key="index">
              <!-- {{item}} -->
              <p class="index">
                <span class="circle box-background"></span>
                <span class="circle circle-small" :style="{ 'background-color': lightColor }"></span>
              </p>
              <div class="content">
                <p class="title" @click="toToDeatil(item)"><a  target="_blank" @click="handleTimer">{{ item.subject }}</a></p>
                <p class="desc">
                  {{ item.appSign === 'auth-sso' ? item.createTime ? $dayjs(item.createTime).format('YYYY-MM-DD HH:mm') : '' : item.createTime }} | {{ item.applicantName }}  </p>
              </div>
            </li>
            <li class="cell" v-if="newworkItemDetail.length > 0">
              <p class="workitem-link"  @click="itemclickWorkItem(newworkItemDetail[0])" v-if=" newworkItemDetail[0].workNum > 50 && currentTabIndex > 0">待办数量共计{{ newworkItemDetail[0].workNum }}条，更多请进入系统查看</p>
            </li>
            <li class="cell cell-title-nodata" v-if="newworkItemDetail.length === 0">{{ $t('mqzwdbcl') }}</li>
          </ul>
          <!-- <ul class="home-rt-top-content scrollbar" v-show="currentTabIndex === 0">
            <li class="cell" v-for="(item, index) in workItemList" :key="index">
              <p class="index">
                <span class="circle box-background"></span>
                <span class="circle circle-small" :style="{ 'background-color': lightColor }"></span>
              </p>
              <div class="content">
                <p class="title"><a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a></p>
                <p class="desc">
                  {{ item.appSign === 'auth-sso' ? item.createTime ? $dayjs(item.createTime).format('YYYY-MM-DD HH:mm') : '' : item.createTime }} |
                  <template v-if="item.appId === 1">统一认证系统</template>
                  <template v-else-if="item.appId === 2">POS系统</template>
                  <template v-else-if="item.appId === 3">费控系统</template>
                  <template v-else-if="item.appId === 4">ERP系统</template>
                   | {{ item.applicantName }}  </p>
              </div>
            </li>
            <li class="cell cell-title-nodata" v-if="workItemList.length === 0">{{ $t('mqzwdbcl') }}</li>
          </ul> -->
          <!-- <ul class="home-rt-top-content scrollbar" v-show="currentTabIndex === 1">
            <li class="cell" v-for="(item, index) in workItemList.filter(k => k.appId === 1)" :key="index">
              <p class="index">
                <span class="circle box-background"></span>
                <span class="circle circle-small" :style="{ 'background-color': lightColor }"></span>
              </p>
              <div class="content">
                <p class="title"><a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a></p>
                <p class="desc">{{ item.createTime ? $dayjs(item.createTime).format('YYYY-MM-DD HH:mm') : '' }} | 统一认证系统 | {{ item.applicantName }}  </p>
              </div>
            </li>
            <li class="cell">
              <p class="workitem-link"  @click="itemclickWorkItem(workItemDetail.ssoUrl, 'hr')" v-if=" workItemDetail.ssoNum > 50 && currentTabIndex === 1">待办数量共计{{ workItemDetail.ssoNum }}条，更多请进入统一认证系统查看</p>
            </li>
            <li class="cell cell-title-nodata" v-if="workItemList.filter(k => k.appId === 1).length === 0">{{ $t('mqzwdbcl') }}</li>
          </ul>
          <ul class="home-rt-top-content scrollbar" v-show="currentTabIndex === 2">
            <li class="cell" v-for="(item, index) in workItemList.filter(k => k.appId === 2)" :key="index">
              <p class="index">
                <span class="circle box-background"></span>
                <span class="circle circle-small" :style="{ 'background-color': lightColor }"></span>
              </p>
              <div class="content">
                <p class="title"><a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a></p>
                <p class="desc">{{ item.createTime }} | POS系统 | {{ item.applicantName }}  </p>
              </div>
            </li>
            <li class="cell">
              <p class="workitem-link"  @click="itemclickWorkItem(workItemDetail.posUrl, 'hr')" v-if=" workItemDetail.posNum > 50 && currentTabIndex === 2">待办数量共计{{ workItemDetail.posNum }}条，更多请进入POS系统查看</p>
            </li>
            <li class="cell cell-title-nodata" v-if="workItemList.filter(k => k.appId === 2).length === 0">{{ $t('mqzwdbcl') }}</li>
          </ul>

          <ul class="home-rt-top-content scrollbar" v-show="currentTabIndex === 3">
            <li class="cell" v-for="(item, index) in workItemList.filter(k => k.appId === 3)" :key="index">
              <p class="index">
                <span class="circle box-background"></span>
                <span class="circle circle-small" :style="{ 'background-color': lightColor }"></span>
              </p>
              <div class="content">
                <p class="title"><a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a></p>
                <p class="desc">{{ item.createTime }} | 费控系统 | {{ item.applicantName }}  </p>
              </div>
            </li>
            <li class="cell">
              <p class="workitem-link" v-if=" workItemDetail.reimNum > 50 && currentTabIndex === 1">待办数量共计{{ workItemDetail.reimNum }}条，更多请进入费控系统查看</p>
            </li>
            <li class="cell cell-title-nodata" v-if="workItemList.filter(k => k.appId === 3).length === 0">{{ $t('mqzwdbcl') }}</li>
          </ul>

          <ul class="home-rt-top-content scrollbar" v-show="currentTabIndex === 4">
            <li class="cell" v-for="(item, index) in workItemList.filter(k => k.appId === 4)" :key="index">
              <p class="index">
                <span class="circle box-background"></span>
                <span class="circle circle-small" :style="{ 'background-color': lightColor }"></span>
              </p>
              <div class="content">
                <p class="title"><a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a></p>
                <p class="desc">{{ item.createTime }} | ERP系统 | {{ item.applicantName }}  </p>
              </div>
            </li>
            <li class="cell">
              <p class="workitem-link" v-if=" workItemDetail.erpNum > 50 && currentTabIndex === 4">待办数量共计{{ workItemDetail.erpNum }}条，更多请进入ERP系统查看</p>
            </li>
            <li class="cell cell-title-nodata" v-if="workItemList.filter(k => k.appId === 4).length === 0">{{ $t('mqzwdbcl') }}</li>
          </ul> -->
          <p class="home-rt-top-block"></p>
        </section>
        <section class="home-rt-bottom">
          <p class="title">{{ $t('homePage.wdyy') }}</p>
          <div class="home-rt-bottom-content scrollbar">
            <div class="cell"
            :title="item.isOpen === 0 ? '暂未开通此系统' : ''"
            :style="{ 'background': isActiveCell === `isActiveCell${index}` ? lightColor : '#fff' }"
            @mouseover="handleMouseover($event, index)"
            @mouseleave="handleMouseleave($event, index)"
            v-for="(item, index) in appList" :key="item.appId">
              <div v-if="item.logoUrl === null || item.logoUrl === ''">
                <div class="name"  @click="itemClick(item)" :title="item.isOpen === 0 ? '暂未开通此系统' : ''" v-if="item.appSign !== 'auth-mail'">
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-if="item.appSign === 'auth-sso'" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-6`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="['auth-hr'].includes(item.appSign)" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-1`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="['auth-sap-bw'].includes(item.appSign)" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-1`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-oa'" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-3`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-crm'" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-4`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-reim'" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-5`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-sap-po'" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-sap`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="item.appSign === 'auth-api-gateway'" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-api`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="['auth-rets-fh'].includes(item.appSign)" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-zhuisu`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else-if="['auth-retsyh'].includes(item.appSign)" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-zhuisu`"></use>
                    </svg>
                  </span>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" v-else :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-${appIconList[(index + 1) % 9]}`"></use>
                    </svg>
                  </span>
                  <span class="text">{{ item.appName }}</span>
                </div>
                <div class="name" style="flex:3;" @click="itemClick(item)" :title="item.isOpen === 0 ? '暂未开通此系统' : ''" v-else>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-2`"></use>
                    </svg>
                  </span>
                  <span class="text">{{ item.appName }}</span>
                </div>
              </div>
              <div v-else>
                <div class="name"  @click="itemClick(item)" :title="item.isOpen === 0 ? '暂未开通此系统' : ''" v-if="item.appSign !== 'auth-mail'">
                  <span  :disabled="item.isOpen === 0">
                    <img :src="item.logoUrl" alt="" class="item-img">
                  </span>
                  <span class="text" style="padding-top: 10px;display: inline-block;padding-left: 13px;">{{ item.appName }}</span>
                </div>
                <div class="name" style="flex:3;" @click="itemClick(item)" :title="item.isOpen === 0 ? '暂未开通此系统' : ''" v-else>
                  <span :class="`circle circle-${appColorList[(index + 1) % 9]}`" :disabled="item.isOpen === 0">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="`#icon-2`"></use>
                    </svg>
                  </span>
                  <span class="text">{{ item.appName }}</span>
                </div>
              </div>
                <div style="text-align:center;flex:.5;margin-top:2px;" v-if="item.appSign === 'auth-sso'">
                  <Badge style="top:-2px;" class-name="box-background"  :count="item.newMailCount" ></Badge>
                </div>
                <span class="icon-svg" :title="item.isOpen === 0 ? '暂未开通此系统' : ''">
                  <a :href="`dingtalk://dingtalkclient/action/sendmsg?spm=ding_open_doc.document.${Math.random()}&dingtalk_id=${item.ddAdminAccount}`" v-if="item.ddAdminAccount">
                    <svg class="icon" aria-hidden="true" :style="{ 'color': primaryColor }">
                      <use xlink:href="#icon-dingding"></use>
                    </svg>
                  </a>
                  <svg class="icon" aria-hidden="true" :style="{ 'color': '#999' }" v-else>
                    <use xlink:href="#icon-dingding"></use>
                  </svg>
                </span>
            </div>
          </div>
        </section>
      </div>
    </section>
    <!-- 切换语言 -->
    <Modal class-name="modal-container" v-model="languagesModalShow" width="450">
      <p slot="header" class="modal-title">{{ $t('homePage.xtyyxz') }}</p>
      <div class="modal-content">
        <div class="items" v-for="item in languageList" :key="item.id" @click="handleSetDefaultLanguage(item)">
          <p class="checked" v-show="item.isDefault === 1" :style="{ 'background-color': item.isDefault === 1 ? primaryColor : '#333' }">
            <Icon class="icon" type="md-checkmark"/>
          </p>
          <template v-if="item.name.includes('简体')">
            <img src="../assets/images/lan1.png"/>
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.zwjt') }}</p>
          </template>
          <template v-else-if="item.name.includes('繁体')">
            <img src="../assets/images/lan2.png"/>
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.zwft') }}</p>
          </template>
          <template v-else-if="['英文', 'english', 'English'].includes(item.name)">
            <img src="../assets/images/lan3.png"/>
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.yw') }}</p>
          </template>
          <template v-else-if="['泰语'].includes(item.name)">
            <img src="../assets/images/lan4.png"/>
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.ty') }}</p>
          </template>
          <template v-else-if="['韩语'].includes(item.name)">
            <img src="../assets/images/lan5.png"/>
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ $t('homePage.hy') }}</p>
          </template>
          <template v-else>
            <img src="../assets/images/logo-block.png"/>
            <p class="name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ item.name }}</p>
          </template>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="languagesModalShow = false, doGetLanguages()">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetDefaultLanguage">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 切换登录背景效果 -->
    <Modal class-name="modal-container" v-model="loginStyleModalShow" width="450">
      <p slot="header" class="modal-title">{{ $t('homePage.dlbjxgqh') }}</p>
      <div class="modal-content">
        <div class="items" v-for="item in bgList" :key="item.id" @click="handleSetBg(item)">
          <p class="checked" :style="{ 'background-color': item.isDefault === 1 ? primaryColor : '#333' }" v-show="item.isDefault === 1">
            <Icon class="icon" type="md-checkmark"/>
          </p>
          <svg class="icon icon-normal text-color" aria-hidden="true" v-show="item.bgLayout === 'center'">
            <use xlink:href="#icon-bac2"></use>
          </svg>
          <svg class="icon icon-normal text-color" aria-hidden="true" v-show="item.bgLayout === 'right'">
            <use xlink:href="#icon-bac3"></use>
          </svg>
          <span class="bj-light" :style="{ 'background-color': lightColor }"></span>
          <p class="back-name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ item.subject | subStr }}</p>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="loginStyleModalShow = false, doGetBgList()">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetBg">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 切换代理人 -->
    <Modal class-name="modal-container" v-model="agentModalShow" width="450">
      <p slot="header" class="modal-title">{{ $t('homePage.qhdlr') }}</p>
      <div class="modal-content" v-if="agentList.length > 0">
        <div class="items" v-for="item in agentList" :key="item.id" @click="handleSetAgent(item)">
          <p class="checked" v-show="item.isDefault === 1" :style="{ 'background-color': item.isDefault === 1 ? primaryColor : '#333' }">
            <Icon class="icon" type="md-checkmark"/>
          </p>
          <img :src="item.headImg" v-if="item.headImg"/>
          <img src="../assets/images/avator.png" v-else/>
          <p class="name back-name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ item.agentUserName }}</p>
          <p class="name back-name" :active="item.isDefault === 1" :style="{ 'color': item.isDefault === 1 ? primaryColor : '#333' }">{{ item.agentUserCode }}</p>
        </div>
      </div>
      <div class="modal-content modal-content-center" v-else>
        空
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="agentModalShow = false, doGetAgentList()">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetAgent">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 切换皮肤 -->
    <Modal class-name="modal-container" v-model="skinModalShow" width="450">
      <p slot="header" class="modal-title">{{ $t('homePage.xtpfqh') }}</p>
      <div class="modal-content">
        <div class="items" v-for="item in skinList" :key="item.id" @click="handleSetDefaultSkin(item)">
          <p class="checked" v-show="item.isDefault === 1" :style="{ 'background-color': item.isDefault === 1 ? primaryColor : '#333' }">
            <Icon class="icon" type="md-checkmark"/>
          </p>
          <p class="skin-box" :style="{ 'background': item.skinColor }"></p>
        </div>
      </div>
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="skinModalShow = false, doCancelSkin">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doSetDefaultSkin">{{ $t('qr') }}</Button>
      </div>
    </Modal>

    <!-- 修改密码 -->
    <Modal class-name="modal-container" v-model="pwdModalShow" width="450">
      <p slot="header" class="modal-title">{{ $t('loginPage.xgmm') }}</p>
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120" style="width: 80%;">
        <FormItem :label="$t('loginPage.ymm')" prop="oldPassword">
          <Input v-model="formValidate.oldPassword" :placeholder="$t('loginPage.ymm')" type="password"></Input>
        </FormItem>
        <FormItem :label="$t('loginPage.xmm')" prop="password">
          <Input v-model="formValidate.password" :placeholder="$t('loginPage.xmm')" type="password"></Input>
        </FormItem>
        <FormItem :label="$t('loginPage.qrxmm')" prop="newPassword">
          <Input v-model="formValidate.newPassword" :placeholder="$t('loginPage.qrxmm')" type="password"></Input>
        </FormItem>
      </Form>
      <!-- <p style="padding: 0 24px;">{{ $t('mmzs') }}</p> -->
      <div slot="footer" class="modal-footer">
        <Button class="button" shape="circle" @click="pwdModalShow = false, doResetForm">{{ $t('qx') }}</Button>
        <Button class="button" type="primary" shape="circle" @click="doUpdatePwd">{{ $t('qr') }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
import { session, cookie } from '../libs/location'
export default {
  data () {
    return {
      title: '',
      childWindow: [], // 打开的窗口集合
      userInfo: '',
      lightColor: '',
      primaryColor: '',
      color: '',
      languagesModalShow: false,
      languageList: [],
      // tab
      currentTabIndex: 0,
      newTodoList: [
        {
          id: 1,
          appName: '全部'
        }
      ],
      todoList: [
        {
          id: 1,
          name: '全部'
        },
        {
          id: 2,
          name: 'SSO'
        },
        {
          id: 3,
          name: 'POS'
        },
        {
          id: 4,
          name: '费控'
        },
        {
          id: 5,
          name: 'ERP'
        }
      ],
      // 预置背景列表
      bgList: [],
      // 登录背景效果切换
      loginStyleModalShow: false,
      isActiveLoginStyle: '',
      // 切换代理人
      agentModalShow: false,
      agentList: [],
      // 切换皮肤
      skinModalShow: false,
      skinList: [
        {
          id: 1,
          skinColor: '#C8291D',
          isDefault: 1
        },
        {
          id: 2,
          skinColor: '#00A497',
          isDefault: 0
        },
        {
          id: 3,
          skinColor: '#F6A902',
          isDefault: 0
        },
        {
          id: 4,
          skinColor: '#00A8FE',
          isDefault: 0
        }
      ],
      // 上传头像
      avatorUrlInit: require('../assets/images/avator.png'),
      avatorUrl: '',
      // 待办列表
      workItemList: [],
      workItemDetail: {
        ssoNum: null,
        ssoUrl: null,
        posNum: null,
        posUrl: null,
        erpNum: null,
        erpUrl: null,
        reimNum: null,
        reimUrl: null
      },
      totalworkItemList: [], // 全部代办列表
      newworkItemDetail: [], // 详细的代办列表
      timer: null,
      timerTwo: null,
      // 应用列表
      appList: [],
      appColorList: ['yellow', 'cyan', 'blue', 'green', 'orange', 'red', 'color1', 'color2', 'color3'],
      appIconList: ['1', '2', '3', '4', '5', '6'],
      isAdmin: false,
      // 修改密码
      pwdModalShow: false,
      formValidate: {
        oldPassword: null,
        password: null,
        newPassword: null
      },
      ruleValidate: {
        oldPassword: [
          { required: true, message: this.$t('loginPage.ymmbnwk'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('loginPage.mmbnwk'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: this.$t('loginPage.mmbnwk'), trigger: 'blur' }
        ]
      },
      isActiveCell: 'isActiveCell'
    }
  },
  filters: {
    subStr (val) {
      return val && val.length > 4 ? val.slice(0, 3) + '...' : val
    }
  },
  watch: {
    '$route' (to, from) {
      // 这样就可以获取到变化的参数了，然后执行参数变化后相应的逻辑就行了
      console.log(this.$route.query, 'kkkkkkk')
    }
  },
  computed: {
    settingData () {
      return this.$store.state.settingData
    }
  },
  created () {
    this.doGetUserInfo()
    this.title = this.title = this.$store.state.loginData.sysLogoTitle.sys_portal_title
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.timerTwo)
  },
  methods: {
    handleMouseover (e, index) {
      this.isActiveCell = `isActiveCell${index}`
    },
    handleMouseleave (e, index) {
      this.isActiveCell = `isActiveCell`
    },
    // 待办轮询
    setTimer (intMilliecond) {
      this.timer = setInterval(() => {
        this.doGetWorkItemList()
      }, intMilliecond)
    },
    toToDeatil (item) {
      if (item.dealPath != '') {
        if (item.appSign === 'sso-inform') {
          window.open(`http://${window.location.host}/qc-sso/inform-page?authorization=${JSON.parse(session.getItem('token'))}&informId=${item.workItemId}`)
        } else {
          window.open(item.dealPath)
        } 
      }
    },
    handleTimer () {
      let that = this
      if (this.timerTwo === null) {
        this.timerTwo = setInterval(() => {
          that.$request.post('/sso/workItem/findIsNeedReload').then(res => {
            const { code, data } = res.data
            if (code === 'OK') {
              console.log(data, 'data')
              if (data) {
                clearInterval(that.timer)
                that.doGetWorkItemList()
                that.setTimer(300000)
                clearInterval(that.timerTwo)
                that.timerTwo = null
              }
            }
          })
        }, 4000)
      }
    },
    itemclickWorkItem (data) {
      console.log(data, 'data')
      // integrateOpenType：0表示同我的应用列表中点击应用的效果、1表示直接在浏览器打开新窗口：toWorkList
      if (data.integrateOpenType === 1) {
        window.open(data.toWorkList)
      } else {
        this.itemClick({ appSign: data.appSign, isOpen: 1 })
      }
    },
    // 我的应用列表跳转
    itemClick (item) {
      if (item.isOpen === 0) {
        return false
      }
      if (item.appSign) {
        let cookieName = ''
        let car = ['dlcd.dolinkhub.com']
        if (car.indexOf(window.location.host) !== -1) {
          cookieName = `token${window.document.location.href.split('/')[3]}`
        } else {
          cookieName = 'token'
        }
        let _token = cookie.getCookie(cookieName)
        // let _token = session.getItem('token').replace(/\"/g, '')
        this.$request.post('/sso/sync/loginOutInfo').then(res => {
          let { code } = res.data
          if (code === 'OK') {
            window.open(`${this.$baseUrl}/sso/redirect/autoLogin?appSign=${item.appSign}&authorization=${_token}`, `sso${item.appSign}`)
            // window.open(`http://192.168.0.109:8081/sso/redirect/autoLogin?appSign=${item.appSign}&authorization=${_token}`, `sso${item.appSign}`)
          }
        })
      }
    },
    doJumpExternalLinks () {
      // this.showLinks = !this.showLinks
      let newpage = this.$router.resolve({ name: 'link' })
      window.open(newpage.href, 'ssoexl')
    },
    onClickLogin () {
      this.$request.post('/sso/login/logoutUser', { sessionId: session.getItem('token') }).then(res => {
        let { code } = res.data
        if (code === 'OK') {
          sessionStorage.clear() // 清除session全部信息
          let car = ['dlcd.dolinkhub.com','localhost:8080']
          let cookieName = ''
          if (car.indexOf(window.location.host) !== -1) {
            cookieName = `token${window.document.location.href.split('/')[3]}`
          } else {
            cookieName = 'token'
          }
          cookie.removeCookie(cookieName)
          this.$router.push({ name: 'login' })
          this.childWindow.forEach(item => {
            item.close()
          })
        }
      })
    },
    // 查询用户基本信息
    doGetUserInfo () {
      this.$request.post('/sso/userAttr/findUserInfo').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          this.userInfo = data
          session.setItem('userInfo', JSON.stringify(data))
          this.$store.dispatch('doChangeSkin', data.skinColor)
          this.doGetAppList()
          this.doGetWorkItemList()
          this.setTimer(300000)
          this.isAdmin = JSON.parse(session.getItem('userInfo')).id === 0
          this.avatorUrl = data.headImg
          // 设置语言
          this.$i18n.locale = data.languageSign
          let _color = this.handleTurnColorRgb(JSON.parse(session.getItem('userInfo')).skinColor)
          this.lightColor = `rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, .2)`
          this.primaryColor = `rgb(${_color[0]}, ${_color[1]}, ${_color[2]})`
        }
      })
    },
    // 16进制颜色值换算成rgb值
    handleTurnColorRgb (colorStr) {
      // 16进制颜色值的正则
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      // 把颜色值变成小写
      let color = colorStr.toLowerCase()
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          let colorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
          }
          color = colorNew
        }
        // 处理六位的颜色值，转为RGB
        let colorChange = []
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt('0x' + color.slice(i, i + 2)))
        }
        return colorChange
      } else {
        return color
      }
    },
    // 上传成功
    handleSuccess (res, file) {
      this.avatorUrl = res.data.url
      this.$request.post('/sso/userAttr/addOrUpdate', { headImg: this.avatorUrl }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          this.$Message.success(this.$t('czcg'))
        }
      })
    },
    // 上传大小控制
    handleMaxSize (file) {
      this.$Message.warning('照片  ' + file.name + ' 太大, 最大不超过 2M.')
    },
    // 获取语言列表
    doGetLanguages () {
      this.$request.post('/sso/language/findList').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          this.languageList = data.map(n => {
            if (n.keySign === JSON.parse(session.getItem('userInfo')).languageSign) {
              n.isDefault = 1
            } else {
              n.isDefault = 0
            }
            return n
          })
        }
      })
    },
    // 语言选择效果
    handleSetDefaultLanguage (item) {
      this.languageList.forEach(n => {
        if (n.keySign === item.keySign) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 设置默认语言列表
    doSetDefaultLanguage () {
      this.languagesModalShow = false
      // 切换语言
      let _data = this.languageList.find(n => n.isDefault === 1)
      this.$i18n.locale = _data.keySign
      this.$request.post('/sso/userAttr/addOrUpdate', { languageSign: _data.keySign }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          // 更新缓存
          let _userInfo = JSON.parse(session.getItem('userInfo'))
          _userInfo.languageSign = _data.keySign
          _userInfo.languageChar = _data.languageChar
          this.userInfo = _userInfo
          session.setItem('userInfo', JSON.stringify(_userInfo))
          this.$Message.success(this.$t('czcg'))
        }
      })
    },
    // 获取预置背景列表
    doGetBgList () {
      this.$request.post('/sso/backgroundSet/findList').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          this.bgList = data.map(n => {
            if (n.id === this.settingData.id) {
              n.isDefault = 1
            } else {
              n.isDefault = 0
            }
            return n
          })
        }
      })
    },
    // 背景切换效果
    handleSetBg (item) {
      this.bgList.forEach(n => {
        if (n.id === item.id) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 设置登录背景效果切换
    doSetBg () {
      this.loginStyleModalShow = false
      let _data = this.bgList.find(n => n.isDefault === 1)
      this.$request.post('/sso/backgroundSet/updateIsUse', { id: _data.id }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          // 更新状态机
          this.store.$commit('handleSettingData', _data)
          this.$Message.success(this.$t('czcg'))
        }
      })
    },
    // 获取代理人列表
    doGetAgentList () {
      this.$request.post('/sso/userAgent/findUserAgent', { userId: this.userInfo.userId }).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          this.agentList = data.map(n => {
            n.isDefault = 0
            return n
          })
        }
      })
    },
    // 代理人切换效果
    handleSetAgent (item) {
      this.agentList.forEach(n => {
        if (n.agentUserId === item.agentUserId) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 切换设置代理人
    doSetAgent () {
      this.agentModalShow = false
      let _data = this.agentList.find(n => n.isDefault === 1)
      this.$request.post('/sso/login/userLoginForAgent', { id: _data.agentUserId }).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          session.clear()
          // session.setObject(data.sessionId)
          session.setItem('userInfo', JSON.stringify(data))
          let car = ['dlcd.dolinkhub.com']
          if (car.indexOf(window.location.host) !== -1) {
            cookie.setCookie(`token${window.document.location.href.split('/')[3]}`, data.sessionId)
          } else {
            cookie.setCookie(`token`, data.sessionId)
          }
          // cookie.setCookie('token', data.sessionId)
          cookie.setCookie('userInfo', JSON.stringify(data))
          // 判断是否是扫码登录的
          if (this.$route.query.token) {
            console.log(11111)
            this.$router.replace({ name: 'home', query: { 'token': data.sessionId, 'key': Math.random } })
            setTimeout(() => {
              this.$router.go(0)
            }, 200)
          } else {
            this.$router.push({ name: 'home' })
            window.location.reload()
          }
        }
      })
    },
    // 获取皮肤列表
    doGetSkinList () {
      this.$request.post('/sso/userAttr/findSkinColor').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          let _skinList = JSON.parse(JSON.stringify(data))
          this.skinList = _skinList.map(k => {
            if (k.skinColor === JSON.parse(session.getItem('userInfo')).skinColor) {
              k.isDefault = 1
            } else {
              k.isDefault = 0
            }
            return k
          })
        }
      })
    },
    // 皮肤切换效果
    handleSetDefaultSkin (item) {
      this.skinList.forEach(n => {
        if (n.skinColor === item.skinColor) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 恢复原皮肤
    doCancelSkin () {
      this.skinList.forEach(n => {
        if (n.skinColor === JSON.parse(session.getItem('userInfo')).skinColor) {
          n.isDefault = 1
        } else {
          n.isDefault = 0
        }
      })
    },
    // 切换设置皮肤
    doSetDefaultSkin () {
      let _data = this.skinList.find(n => n.isDefault === 1)
      this.$store.dispatch('doChangeSkin', _data.skinColor)

      let _color = this.handleTurnColorRgb(_data.skinColor)
      this.lightColor = `rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, .2)`
      this.primaryColor = `rgb(${_color[0]}, ${_color[1]}, ${_color[2]})`
      this.skinModalShow = false

      this.$request.post('/sso/userAttr/addOrUpdate', { skinColor: _data.skinColor }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          // 更新缓存
          let _userInfo = JSON.parse(session.getItem('userInfo'))
          _userInfo.skinColor = _data.skinColor
          session.setItem('userInfo', JSON.stringify(_userInfo))
          this.$Message.success(this.$t('czcg'))
        }
      })
    },
    // 切换代办列表
    checkTop (data, index) {
      this.newworkItemDetail = []
      this.currentTabIndex = index
      console.log(data, index)
      this.totalworkItemList.forEach(item => {
        if (item.appSign === data.appSign) {
          this.newworkItemDetail.push(Object.assign({}, data, item))
        }
      })
      console.log(this.newworkItemDetail, 'this.newworkItemDetail')
    },
    // 获取待办列表
    doGetWorkItemList () {
      this.newTodoList = [{ id: 1, appName: '全部' }]
      this.totalworkItemList = []
      this.workItemDetail = []
      this.$request.post('/sso/workItem/findList').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          data.sysList.forEach(item => {
            this.newTodoList.push(item)
          })
          this.totalworkItemList = data.workItemList
          this.workItemDetail = data
          let _pos = data.workItemList && data.workItemList.filter(k => k.appId === 2).length
          let _sso = data.workItemList && data.workItemList.filter(k => k.appId === 1).length
          let _erp = data.workItemList && data.workItemList.filter(k => k.appId === 4).length
          let _fk = data.workItemList && data.workItemList.filter(k => k.appId === 3).length
          this.todoList.forEach(k => {
            k['number'] = 0
            switch (k.name) {
              case '全部':
                k.number = _pos + _sso + _erp + _fk
                break
              case 'POS':
                k.number = _pos
                break
              case 'SSO':
                k.number = _sso
                break
              case 'ERP':
                k.number = _erp
                break
              case '费控':
                k.number = _fk
                break

              default:
                break
            }
          })
          this.workItemList = data.workItemList || []
          console.log(this.newTodoList, 'this.newTodoList')
        }
      })
    },
    // 获取应用列表
    doGetAppList () {
      this.$request.post('/sso/app/getUserAppPage').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          if (data.length > 0) {
            let _copyData = JSON.parse(JSON.stringify(data))
            _copyData.forEach(n => {
              if (n.appSign === 'auth-mail' && n.isOpen === 1) {
                this.doGetEmailCount(n.appCount).then(k => {
                  n.newMailCount = k
                })
              } else {
                n.newMailCount = 0
              }
            })
            this.appList = _copyData
            console.log(_copyData, '_copyData')
          }
        }
      })
    },
    // 查询用户未读邮件个数
    doGetEmailCount (userAccount) {
      return this.$request.get(`/sso/mail/getNewMailInfos?userAccount=${userAccount}`).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          return data
        }
      })
    },
    // 修改密码
    handleUpdatePwd () {
      this.pwdModalShow = true
    },
    // 取消修改密码
    doResetForm () {
      this.formValidate = {
        oldPassword: null,
        password: null,
        newPassword: null
      }
    },
    // 确认修改密码
    doUpdatePwd () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/
          if (
            (!reg.test(
              this.formValidate.password
            ) || /[\u4E00-\u9FA5]/g.test(this.formValidate.password))
          ) {
            this.$Message.warning(this.$t('loginPage.mmzswzmsztszf'))
          } else if (this.formValidate.oldPassword === this.formValidate.password) {
            this.$Message.warning(this.$t('loginPage.xmmbnyjmmxt'))
          } else if (this.formValidate.password !== this.formValidate.newPassword) {
            this.$Message.warning(this.$t('loginPage.mmbyz'))
          } else {
            let req = {
              userCode: this.userInfo.userName,
              password: this.formValidate.password,
              oldPassword: this.formValidate.oldPassword,
              sessionId: this.userInfo.sessionId
            }
            this.$request.post('/sso/login/modPasswordForFirst', req).then(res => {
              const { code } = res.data
              if (code === 'OK') {
                this.doResetForm()
                this.$Message.success(this.$t('czcg'))
                this.pwdModalShow = false
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
.home-logo {
  position: absolute;
  width: 90px;
  left: 120px;
  margin-top: 17px;
  z-index: 999;
}
.item-img{
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.lang-box {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  text-align: center;
  line-height: 80px;
  font-size: 20px;
  font-weight: 800;
  margin: 0 auto;
}
.workitem-link {
  // position: absolute;
  // bottom: 24px;
  // left: 24px;
  font-size: 16px;
  cursor: pointer;
  color: #0792FF;
}
.home-container-blur {
  background: url('../assets/images/home-bg.png') center center no-repeat;
  background-size: cover;
  position: absolute;
  width: 100vw;
  height: 100vh;
  filter: blur(6px);
}
.home-container {
  width: 100vw;
  height: 100vh;
  background: url('../assets/images/home-bg.png') center center no-repeat;
  background-size: cover;
  .container {
    width: 1400px;
    position: relative;
    left: 50%;
    margin-left: -700px;
  }
  .header-content {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 60px;
    line-height: 60px;
    background-color: #C8291D;
    color: #FFFFFF;
    font-size: 18px;
    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .logo-box {
      flex: 1;
      .logo {
        width: 90px;
        vertical-align: middle;
      }
    }
    .login-out {
      flex: 1;
      text-align: right;
      span {
        cursor: pointer;
      }
      .icon {
        color: #FFFFFF;
        margin-right: 8px;
        vertical-align: -8px;
        font-size: 28px;
      }
    }
  }
  .home-content {
    position: relative;
    height: 100%;
    .cell-title-nodata {
      font-size: 16px;
      color: #333;
      height: 83%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .home-lf {
      position: absolute;
      overflow-y: auto;
      width: 420px;
      top: 84px;
      bottom: 24px;
      background-color: #FFFFFF;
      border-radius: 6px;
      box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.06);
      padding: 24px;
      .avator-box {
        border-bottom: 1px dashed #DDDDDD;
        text-align: center;
        .avator {
          margin: 0 auto;
          margin-top: 26px;
          width: 138px;
          height: 138px;
          background-color: transparent;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          border-radius: 50%;
          margin-bottom: 16px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
          }
          .upload-avator {
            position: absolute;
            height: 45px;
            width: 138px;
            line-height: 45px;
            bottom: 0;
            opacity: 0;
            background: rgba(0, 0, 0, 0.4);
            width: 100%;
            color: #FFFFFF;
            transition: .3s;
          }
          &:hover {
            .upload-avator {
              opacity: 1;
            }
          }
        }
        .name {
          font-size: 24px;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
          margin-bottom: 18px;
        }
        .post {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          margin-bottom: 24px;
        }
      }
      .desc-cell {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 16px 0;
        line-height: 20px;
        font-size: 16px;
        font-weight: 400;
        .name {
          color: #666666;
        }
        .desc {
          color: #333333;
          text-align: right;
        }
      }
      .action-box {
        text-align: center;
        padding-top: 24px;
        border-top: 1px dashed #DDDDDD;
        .action-cell {
          display: inline-block;
          cursor: pointer;
          .bg {
            width: 48px;
            height: 48px;
            margin: 0 auto;
            border-radius: 50%;
            background-color: transparent;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 12px;
            .icon {
              font-size: 20px;
              color: #C8291D;
            }
          }
          .name {
            font-size: 16px;
            color: #666666;
            width: 88px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .action-button {
          width: 160px;
          height: 40px;
          line-height: 40px;
          background-color: #C8291D;
          color: #FFFFFF;
          text-align: center;
          border-radius: 24px;
          font-size: 16px;
          margin: 0 auto;
          margin-top: 40px;
          cursor: pointer;
        }
      }
    }
    .home-rt {
      width: 956px;
      position: absolute;
      right: 0;
      top: 84px;
      bottom: 24px;
      .home-rt-top {
        position: absolute;
        top: 4px;
        right: 0;
        width: 956px;
        height: 50%;
        background-color: transparent;
        border-radius: 6px;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.06);
        padding-bottom: 16px;
        background-clip: content-box;
        .home-rt-top-tab {
          display: flex;
          align-items: center;
          background: #F0F0F0;
          height: 44px;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          .tab-cell {
            flex: 1;
            text-align: center;
            position: relative;
            color: #666666;
            font-size: 18px;
            cursor: pointer;
            &::after {
              position: absolute;
              right: 0;
              content: '';
              height: 17px;
              top: 4px;
              width: 1px;
              background-color: #999999;
            }
            &:last-child {
              &::after {
                content: none;
              }
            }
            &[active] {
              margin-top: -3px;
              height: 58px;
              line-height: 58px;
              background: linear-gradient(180deg, #FBF1F0 0%, #FFFFFF 100%);
              border-radius: 6px 12px 0px 0px;
              &::after {
                content: none;
              }
            }
          }
        }
        .home-rt-top-content {
          padding: 0 24px;
          position: absolute;
          top: 44px;
          bottom: 36px;
          width: 100%;
          overflow: hidden;
          overflow-y: auto;
          background-color: #FFFFFF;
          .cell {
            margin-top: 16px;
            display: flex;
            .index {
              flex: 0 0 40px;
              text-align: left;
              margin-top: 4px;
              .circle {
                display: inline-block;
                width: 11px;
                height: 11px;
                border-radius: 50%;
                background-color: #CB3C31;
              }
              .circle-small {
                opacity: .6;
                margin-left: -4px;
              }
            }
            .content {
              display: inline-block;
              flex: 1;
              font-size: 16px;
              line-height: 20px;
              .title {
                color: #333333;
                margin-bottom: 8px;
              }
              .desc {
                color: #999999;
              }
            }
          }
        }
        .home-rt-top-block {
          position: absolute;
          bottom: 24px;
          height: 12px;
          width: 100%;
          background-color: #FFFFFF;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
      .home-rt-bottom {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 956px;
        height: 50%;
        background-color: #FFFFFF;
        border-radius: 6px;
        padding: 24px 0;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        .title {
          font-size: 18px;
          color: #333333;
          font-weight: bold;
          line-height: 22px;
          padding: 0 24px;
        }
        .home-rt-bottom-content {
          display: flex;
          flex-wrap: wrap;
          overflow: hidden;
          overflow-y: auto;
          position: absolute;
          padding: 0 24px;
          left: 0;
          right: 0;
          top: 46px;
          bottom: 24px;
          align-content: flex-start;
          .cell {
            flex: 0 0 32%;
            width: 32%;
            float: left;
            margin-right: 1.3%;
            margin-top: 16px;
            height: 80px;
            background: #FFFFFF;
            border-radius: 6px;
            border: 1px solid #F6F6F6;
            padding: 18px 24px;
            color: #333333;
            font-size: 18px;
            display: flex;
            align-items: center;
            cursor: pointer;
            div {
              display: inline-block;
            }
            .name {
              flex: 9;
              font-size: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .circle {
                display: inline-block;
                line-height: 44px;
                text-align: center;
                margin-right: 12px;
                width: 44px;
                height: 44px;
                border-radius: 22px;
                &[disabled] {
                  background: #ddd;
                }
                &-yellow {
                  background: linear-gradient(136deg, #FFD84F 0%, #FE9B4C 100%);
                }
                &-cyan {
                  background: linear-gradient(136deg, #14D6D6 0%, #14BAB7 100%);
                }
                &-blue {
                  background: linear-gradient(136deg, #42ACFF 0%, #0792FF 100%);
                }
                &-green {
                  background: linear-gradient(136deg, #2AE098 0%, #13BA7B 100%);
                }
                &-orange {
                  background: linear-gradient(136deg, #FD8541 0%, #FD7021 100%);
                }
                &-red {
                  background: linear-gradient(136deg, #FE7373 0%, #E23130 100%);
                }
                &-color1 {
                  background: linear-gradient(136deg, #E57FD2 0%, #E694D7 100%);
                }
                &-color2 {
                  background: linear-gradient(136deg, #8BE6DB 0%, #99E5DC 100%);
                }
                &-color3 {
                  background: linear-gradient(136deg, #E28694 0%, #E297A2 100%);
                }
              }
              .icon {
                color: #FFFFFF;
                font-size: 24px;
              }
            }
            .icon-svg {
              text-align: right;
              flex: .5;
              .icon {
                color: #999999;
                &[active] {
                  color: #0792FF;
                }
              }
            }
          }
        }
      }
    }
  }
}
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal{
      top: 0;
  }
  .ivu-modal-body {
    padding: 0;
    padding-top: 16px;
  }
  .modal-title {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
  }
  .modal-content {
    display: flex;
    // justify-content: center;
    // align-items: center;
    flex-wrap: wrap;
    max-height: 360px;
    min-height: 130px;
    overflow-y: auto;
    &-center {
      justify-content: center;
    }
    .items {
      flex: 0 0 20%;
      position: relative;
      box-sizing: border-box;
      padding: 12px;
      text-align: center;
      img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-bottom: 8px;
      }
      .name {
        text-align: center;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        height: 44px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
        &[active] {
          color: #C8291D;
        }
      }
      .icon-normal {
        width: 38px;
        height: 38px;
        margin: 22px;
      }
      .back-name {
        line-height: 22px;
        height: auto;
      }
      .bj-light {
        position: absolute;
        top: 22px;
        left: 20px;
        width: 64px;
        height: 64px;
        background: #C8291D;
        border-radius: 8px;
        opacity: 0.5;
      }
      .checked {
        position: absolute;
        right: 26%;
        top: 12px;
        border: 2px solid #FFFFFF;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #C8291D;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
          color: #FFFFFF;
          font-size: 16px;
        }
      }
    }
    .skin-box {
      width: 64px;
      height: 64px;
      border-radius: 50%;
    }
  }
  .modal-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    .button {
      width: 150px;
    }
  }
}
</style>
